module.exports = __webpack_public_path__ + "img/1f3d5.1a6afb4.svg";